/**
 * @fileoverview POST handler for the "/engagement/report_tile" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportTileCacheKeys } from "./constants";
import type { PostEngagementReportTileProps, EngagementReportTileResult } from "./types";

export const postEngagementReportTile = reactQueryMutationAdapter(
  engagementReportTileCacheKeys,
  (props: PostEngagementReportTileProps): Promise<EngagementReportTileResult> => {
    return fetch("/engagement/report_tile", "POST", props);
  }
);
